import React from "react";

const Expertise = () => {
  const column1 = [
    { name: "AI Agent Development", isAI: true },
    { name: "AngularJS", iconClass: "devicon-angularjs-plain" },
    { name: "Vue JS", iconClass: "devicon-vuejs-plain" },
    { name: "React JS", iconClass: "devicon-react-original" },
    { name: "Next.Js", iconClass: "devicon-nextjs-plain" },
    { name: "Node JS", iconClass: "devicon-nodejs-plain" },
    { name: "Android App", iconClass: "devicon-android-plain" },
  ];

  const column2 = [
    { name: "AI Chatbot Implementation", isAI: true },
    { name: "Flutter", iconClass: "devicon-flutter-plain" },
    { name: "React Native", iconClass: "devicon-react-original" },
    { 
      name: "PWA", 
      icon: (
        <svg viewBox="0 0 24 24" width="28" height="28" className="mr-3 svg-icon" style={{ fill: "#e5dcf2", display: "inline-block", verticalAlign: "middle" }}>
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15.5h-2V15h2v2.5zm0-4.5h-2V7h2v6z" />
        </svg>
      )
    },
    { name: "PHP", iconClass: "devicon-php-plain" },
    { name: "Python", iconClass: "devicon-python-plain" },
    { name: "Strapi", iconClass: "devicon-strapi-plain" },
  ];

  const column3 = [
    { name: "Generative AI Integration", isAI: true },
    { name: "Webflow", iconClass: "devicon-webflow-original" },
    { name: "Drupal", iconClass: "devicon-drupal-plain" },
    { name: "WordPress", iconClass: "devicon-wordpress-plain" },
    { name: "WooCommerce", iconClass: "devicon-woocommerce-plain" },
    { 
      name: "Big Commerce", 
      icon: (
        <svg viewBox="0 0 24 24" width="28" height="28" className="mr-3 svg-icon" style={{ fill: "#e5dcf2", display: "inline-block", verticalAlign: "middle" }}>
          <path d="M17.21 9l-4.4-4.8c-.3-.3-.8-.3-1.1 0L3.5 12.8c-.3.3-.3.8 0 1.1l8.2 8.2c.3.3.8.3 1.1 0l4.4-4.8 3.3 3.3c.3.3.8.3 1.1 0l2.2-2.2c.3-.3.3-.8 0-1.1L17.2 9zM12.5 19L6.3 12.8 12.5 6.6l6.2 6.2L12.5 19z" />
        </svg>
      )
    },
    { name: "Adobe Commerce", iconClass: "devicon-magento-original" },
  ];

  const finalColumn4 = [
    { name: "Custom AI Model Development", isAI: true },
    { name: "iOS", iconClass: "devicon-apple-original" },
    { name: "Shopify", iconClass: "devicon-shopify-plain" },
    { name: ".Net", iconClass: "devicon-dotnetcore-plain" },
    { 
      name: "IoT", 
      icon: (
        <svg viewBox="0 0 24 24" width="28" height="28" className="mr-3 svg-icon" style={{ fill: "#e5dcf2", display: "inline-block", verticalAlign: "middle" }}>
          <path d="M12 3c-4.97 0-9 4.03-9 9 0 2.12.74 4.07 1.97 5.61L4.35 19c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l1.9-1.9C9.17 19.49 10.53 20.25 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 15c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z" />
        </svg>
      )
    },
    { name: "Java", iconClass: "devicon-java-plain" },
  ];

  const aiIcon = (
    <svg viewBox="0 0 24 24" width="28" height="28" className="mr-3 svg-icon" style={{ fill: "#007bff", display: "inline-block", verticalAlign: "middle", flexShrink: 0 }}>
      <path d="M12 2a2 2 0 0 1 2 2c0 .74-.4 1.39-1 1.73V7h1a7 7 0 0 1 7 7h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1H2a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a7 7 0 0 1 7-7h1V5.73c-.6-.34-1-.99-1-1.73a2 2 0 0 1 2-2M7.5 13A2.5 2.5 0 0 0 5 15.5 2.5 2.5 0 0 0 7.5 18 2.5 2.5 0 0 0 10 15.5 2.5 2.5 0 0 0 7.5 13m9 0A2.5 2.5 0 0 0 14 15.5a2.5 2.5 0 0 0 2.5 2.5 2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 16.5 13z"/>
    </svg>
  );

  const renderTechList = (items) => {
    return items.map((item, index) => (
      <div key={index} className={`tech-item d-flex align-items-center mb-4${item.isAI ? ' ai-item' : ''}`}>
        {item.isAI ? (
          aiIcon
        ) : item.icon ? (
          item.icon
        ) : (
          <i className={`${item.iconClass} mr-3`} style={{ fontSize: "28px", width: "32px", textAlign: "center", display: "inline-block", verticalAlign: "middle" }}></i>
        )}
        <span style={{ fontSize: "17px", fontWeight: item.isAI ? '700' : '500', verticalAlign: "middle" }}>{item.name}</span>
      </div>
    ));
  };

  return (
    <>
      <style>{`
        #expertise {
          background: #291a2e;
          padding: 80px 0 60px 0;
          color: #e5dcf2;
        }
        #expertise .section-header h3 {
          color: #ffffff;
        }
        #expertise .section-header h3::before,
        #expertise .section-header h3::after {
          background: #ffffff;
        }
        #expertise .section-header p {
          color: #bfaec4;
          font-weight: 400;
        }
        .tech-item {
          padding: 12px 18px;
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.06);
          border: 1px solid rgba(255, 255, 255, 0.08);
          transition: all 0.35s cubic-bezier(0.165, 0.84, 0.44, 1);
        }
        .tech-item:hover {
          background: rgba(255, 255, 255, 0.12);
          transform: translateY(-4px) scale(1.03);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        }
        .tech-item i,
        .tech-item svg {
          color: #e5dcf2;
          fill: #e5dcf2;
          transition: transform 0.35s ease;
        }
        .tech-item:hover i,
        .tech-item:hover svg {
          transform: scale(1.18);
          color: #007bff;
          fill: #007bff;
        }
        .tech-item span {
          color: #e5dcf2;
          transition: color 0.35s ease;
        }
        .tech-item:hover span {
          color: #007bff;
        }
        .ai-item {
          background: linear-gradient(135deg, rgba(0,123,255,0.12), rgba(0,198,255,0.06)) !important;
          border-color: rgba(0,123,255,0.35) !important;
          box-shadow: 0 0 12px rgba(0,123,255,0.12);
        }
        .ai-item span {
          color: #5ba4ff !important;
          font-weight: 700 !important;
        }
        .ai-item:hover {
          box-shadow: 0 8px 24px rgba(0,123,255,0.25) !important;
          border-color: #007bff !important;
        }
      `}</style>
      <section id="expertise" className="wow fadeIn">
        <div className="container">
          <header className="section-header">
            <h3>Our Expertise</h3>
            <p>
              We specialize in a wide range of modern technologies, frameworks, and ecommerce platforms
              to deliver top-tier, high-performance web and mobile applications.
            </p>
          </header>

          <div className="row mt-5">
            <div className="col-lg-3 col-md-6 pl-4 pl-md-5">
              {renderTechList(column1)}
            </div>
            <div className="col-lg-3 col-md-6 pl-4 pl-md-5">
              {renderTechList(column2)}
            </div>
            <div className="col-lg-3 col-md-6 pl-4 pl-md-5">
              {renderTechList(column3)}
            </div>
            <div className="col-lg-3 col-md-6 pl-4 pl-md-5">
              {renderTechList(finalColumn4)}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Expertise;
